<span class="inline-flex" [matTooltip]="computedTooltip" (click)="onClick($event)">
  @if (genericRouteName) {
    <a mat-icon-button [mxNamedRouterLink]="genericRouteName" [mxNamedRouterLinkParams]="routeParams" [mxQueryParams]="queryParams"
       [mxNamedRouterLinkEnabled]="enabled" [color]="color" [attr.aria-disabled]="computedAriaDisabled" [attr.tabindex]="computedTabIndex"
       [attr.aria-label]="computedAriaLabel" class="mx-button-component {{ buttonClasses }}">
      <ng-container *ngTemplateOutlet="buttonContent"/>
    </a>
  } @else if (href) {
    <a mat-icon-button [attr.href]="computedHref" [attr.target]="externalLinkTarget" [attr.rel]="externalLinkRelationship" [color]="color"
       [attr.aria-disabled]="computedAriaDisabled" [attr.tabindex]="computedTabIndex" [attr.aria-label]="computedAriaLabel"
       class="mx-button-component {{ buttonClasses }}">
      <ng-container *ngTemplateOutlet="buttonContent"/>
    </a>
  } @else {
    <button mat-icon-button [type]="type" [color]="color" [disabled]="!enabled" [attr.aria-label]="computedAriaLabel"
            class="mx-button-component {{ buttonClasses }}">
      <ng-container *ngTemplateOutlet="buttonContent"/>
    </button>
  }
</span>

<ng-template #buttonContent>
  @if (customContentTemplate) {
    <span class="mx-button-custom-content">
      <ng-container [ngTemplateOutlet]="customContentTemplate"/>
    </span>
  } @else {
    <span class="relative inline-flex">
      <mat-icon [class]="iconClasses" [class.material-icons-outlined]="iconOutlined">{{ icon }}</mat-icon>

      @if (showStatusDot) {
        <span class="absolute top-1 right-1 size-[0.4375rem] rounded-full bg-error z-10"></span>
      }
    </span>
  }
</ng-template>
